export default __webpack_public_path__ + "static/media/return.317647e8.svg";